/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyEvaluation = {

	delete (context, agencyEvaluationId, onSuccess, onError, options) {
		Api.delete(context,
			"/agency-evaluation"
			+ "?agencyEvaluationId=" + agencyEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, agencyEvaluationId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-evaluation"
			+ "?agencyEvaluationId=" + agencyEvaluationId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAvailableAgencies (context, offerId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-evaluation/available-agencies"
			+ "?offerId=" + offerId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-evaluation/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestEvaluationAuthors (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-evaluation/contest-evaluation-authors"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/agency-evaluation/contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	post (context, offerId, agencyId, onSuccess, onError, options) {
		Api.post(context,
			"/agency-evaluation"
			+ "?offerId=" + offerId
			+ "&agencyId=" + agencyId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, agencyEvaluationId, onSuccess, onError, options) {
		Api.put(context,
			"/agency-evaluation"
			+ "?agencyEvaluationId=" + agencyEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrection (context, evaluationId, correctionCauseDTO, onSuccess, onError, options) {
		Api.put(context,
			"/agency-evaluation/correction"
			+ "?evaluationId=" + evaluationId
			, correctionCauseDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, agencyEvaluationId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/agency-evaluation/data"
			+ "?agencyEvaluationId=" + agencyEvaluationId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, agencyEvaluationId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/agency-evaluation/finish"
			+ "?agencyEvaluationId=" + agencyEvaluationId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
